import _throttle from 'lodash/throttle';

export const trackMatrixView = _throttle(function () {
    trackBehaviour('viewed matrix');
}, 60000);

export const trackFreeTrialView = function (step) {
    trackBehaviour('Free trial', {'step': step});
};

export const trackHighlightType = _throttle(function (type) {
    trackBehaviour('clicked highlight', {'type': type});
}, 5000);